import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { inject, observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import agent from "../../agent";

const LoginTemplate = inject("commonStore")(
  observer((props) => {
    // useEffect(()=>{
    //     localStorage.clear();
    // },[]);
    const history = useHistory();
    const list = [
      {
        id: "ip1",
        title: "이메일",
        placeholder: "이메일을 입력해주세요",
        type: "text",
        marginRight: "85px",
        value: "",
      },
      {
        id: "ip2",
        title: "비밀번호",
        placeholder: "비밀번호를 입력해주세요",
        type: "password",
        marginRight: "69.5px",
        value: "",
      },
    ];
    const [idPw, setIdPW] = useState(list); //아이디, 비밀번호 state
    const changeHandler = (target, i) => {
      // 아이디, 비밀번호 onchange
      setIdPW([...idPw]);
      idPw[i].value = target;
    };
    const loginHandler = () => {
      if (idPw[0].value === "") {
        alert("이메일을 입력하세요.");
        return;
      }
      if (idPw[1].value === "") {
        alert("비밀번호를 입력하세요.");
        return;
      }

      let dataObject = {
        email: idPw[0].value,
        password: idPw[1].value,
      };

      agent.Auth.login(dataObject)
        .then((res) => {
          history.push("/main");
          props.commonStore.setToken(res.token);
          localStorage.setItem("name", res.name);
          localStorage.setItem("writer_id", res.id);
          localStorage.setItem("level", res.level); //회원 등급 7: 검수자 / 7 미만: 작성자
          localStorage.setItem("menu", 0); // 처음 들어갈 때 칼럼 분류 전체로 설정
          localStorage.setItem("currentPage", 1); //500에러 방지, currentPage null 값 나와서 500에러 발생
          props.commonStore.setAppLoaded(1);
          props.commonStore.setActivePage(1); //페이지 초기화
        })
        .catch((err) => {
          if (err.response.statusCode === 400) {
            alert("이메일 혹은 비밀번호가 틀렸습니다!");
            return;
          }
        });
    };

    const loginEnter = () => {
      //enter키 누를 때
      if (window.event.keyCode === 13) {
        loginHandler();
      }
    };
    return (
      <Box>
        <div>
          <img src={require("../../styles/img/luvd.png")} alt="럽디" />
          <p>칼럼관리자 로그인</p>
          {idPw.map((v, i) => {
            return (
              <div className="inputs" key={v.id}>
                <span style={{ marginRight: v.marginRight }}>{v.title}</span>
                <input
                  type={v.type}
                  placeholder={v.placeholder}
                  autoComplete="new-password"
                  value={v.value}
                  onKeyUp={loginEnter}
                  onChange={(e) => changeHandler(e.target.value, i)}
                />
              </div>
            );
          })}
          <span style={{ color: "gray" }}>스케줄러 계정으로도 로그인 가능합니다.</span>
          <div onClick={loginHandler}>Login</div>
        </div>
      </Box>
    );
  })
);

const Box = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    display: flex;
    width: 600px;
    flex-direction: column;
    align-items: center;

    > img {
      width: 30%;
    }

    > p {
      margin-top: 20px;
      margin-bottom: 50px;
      font-size: 18px;
      font-weight: bold;
    }

    > .inputs {
      border-bottom: 2px solid #e9e9f0;
      width: 80%;
      box-sizing: border-box;
      padding: 10px;
      margin-bottom: 15px;

      > input {
        border: none;
        text-align: center;
      }

      > input::placeholder {
        color: #b7b7b7;
        font-size: 13px;
      }
    }

    > div:last-child {
      background: #43425d;
      width: 80%;
      color: white;
      box-sizing: border-box;
      text-align: center;
      padding: 15px 0;
      margin-top: 50px;
      border-radius: 6px;
      cursor: pointer;
    }
  }
`;

export default LoginTemplate;
